export default "__VITE_ASSET__D2B0Qdm___"